import apolloClient from "@/apollo";
import type { RootState } from "@/store/types";
import gql from "graphql-tag";
import type { ActionContext } from "vuex";
import type { UserState } from "../state";
import type { ChangedAppGroup } from "@/models/user";

const changeAppGroupMutation = gql`
  mutation changeAppGroup($input: ChangeAppGroup) {
    changeAppGroup(input: $input) {
      __typename
      ... on ChangedAppGroup {
        user {
          id
          accountId
          email
          firstName
          lastName
          isAdmin
          lastAppGroupId
          lastAppGroupName
          account {
            billingThreshold
          }
        }
        token
      }
      ... on Corollary {
        code
        message
      }
    }
  }
`;

/**
 * Update the user object and token to a new app group.
 * @param context - User Vuex context from where the function is being called.
 * @param args - Object that encapsulates the arguments
 * @param args.appgroupId - AppGroupId string that is sent as a GraphQL input to the mutation
 */
export async function changeServiceGroup(
  context: ActionContext<UserState, RootState>,
  args: { appgroupId: string }
): Promise<void> {
  const response = await apolloClient.mutate({
    mutation: changeAppGroupMutation,
    variables: {
      input: {
        appgroupId: args.appgroupId,
      },
    },
  });
  const typeName = response.data.changeAppGroup.__typename;
  if (typeName === "ChangedAppGroup") {
    const changedAppGroup: ChangedAppGroup = response.data.changeAppGroup;
    context.commit("setUser", {
      token: changedAppGroup.token,
      user: changedAppGroup.user,
    });
  }
}
